import * as z from 'zod'

import {
  cashFlowList,
  investorList,
  markList,
  optionalText,
  requiredAmount,
  requiredDate,
  requiredText,
  tagList,
  withInvestors,
} from '../utils/schema'

export const privateFundSubscribeAndCommitSchema = withInvestors(
  z.object({
    assetName: requiredText('Name this fund'),
    description: optionalText(),
    amount: requiredAmount('Enter the committed amount'),
    date: requiredDate('Enter the date of investment'),
    currency: optionalText(),
    /*
     * The commitment split across more than one entity — see WizardInvestor.
     * Each becomes its own asset-and-transaction bundle, for its own share.
     */
    investors: investorList(),
    /* What the valuation step recorded, if anything. See markList. */
    prices: markList(),
    /* Capital calls, fees and distributions, if any. See cashFlowList. */
    cashFlows: cashFlowList(),
    tags: tagList(),
  }),
)

export type PrivateFundSubscribeAndCommitValues = z.infer<typeof privateFundSubscribeAndCommitSchema>
